import { Typography } from '@navi/web-ui/lib/primitives';
import AutocompleteDropdown from '@cp/src/components/AutocompleteDropdown/AutocompleteDropdown';
import { ErrorRemovalReasonSectionProps } from '../../interface';
import { noop } from '@navi/web-ui/lib/utils/common';

const ErrorRemovalReasonSection = ({
  removedErrors,
  perViolationReasonOptions,
  errorRemovalReasons,
  onReasonChange
}: ErrorRemovalReasonSectionProps) => {
  if (!removedErrors.length) return null;

  return (
    <div className="flex flex-col gap-3 px-3 pb-3">
      {removedErrors.map(removedError => {
        const reasonOptions = perViolationReasonOptions[removedError.optionId] || [];
        if (!reasonOptions.length) return null;
        const selectedReasons = errorRemovalReasons[removedError.optionId] || [];
        return (
          <div key={removedError.optionId} className="flex flex-col gap-2">
            <Typography variant="h4" color="var(--grayscale-2)">
              Why &quot;{removedError.optionText}&quot; is not correct?
            </Typography>
            <AutocompleteDropdown
              options={reasonOptions}
              selectedOptions={selectedReasons}
              placeholder={selectedReasons.length > 0 ? '' : 'Select reason'}
              onSearch={noop}
              onSelectionChange={options => onReasonChange(removedError.optionId, options)}
              maxSelectedChipToShow={3}
              selectedOptionWrapperClass="bg-[var(--bg-blue)] border-[var(--blue-border)]"
              selectedOptionLabelClass="text-[var(--blue-base)]"
              selectedOptionChipIconColor="var(--blue-base)"
            />
          </div>
        );
      })}
    </div>
  );
};

export default ErrorRemovalReasonSection;
